import { useMemo, useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import '../Assets/css/Main.css'
import base from '../Services/BaseService'
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import { FormatCurrencyCell } from './Functions/NumberFormatter';
import { defaultGridColumnDef } from './Shared/Grid';

const FileModal = ({ closeModal, onImported }) => {
    const [previewClick, setPreviewClick] = useState(false)
    const [previewData, setPreviewData] = useState([]);
    const gridDefaultColDef = defaultGridColumnDef;

    const toggleModal = () => {
        closeModal()
    }

    const importColDef = useMemo(() => [
            {
                headerName: "Account",
                field: "accountId",
                suppressMovable: true,
                maxWidth: 95
            },
            {
                headerName: "Date",
                field: "transactionDate",
                suppressMovable: true,
                maxWidth: 95,
                valueGetter: (params) => {
                    const value = params.data.transactionDate;
                    if (typeof value === "string" && value.includes("T")) {
                        return value.split("T")[0];
                    }
                    return value;
                },
            },
            {
                headerName: "Description",
                field: "transactionDescription",
                suppressMovable: true,
                maxWidth: 500
            },
            {
                headerName: "Category",
                field: "categoryId",
                suppressMovable: true,
                maxWidth: 125
            },
            {
                headerName: "Amount",
                field: "value",
                suppressMovable: true,
                filter: 'agNumberColumnFilter',
                type: 'numericColumn',
                maxWidth: 125,
                valueFormatter: FormatCurrencyCell
            },
        ], []);

    const UploadClick = () => {
        base.add("FileUpload/UploadCommit", "").then(() => {
            if (onImported) {
                onImported();
            } else {
                closeModal();
            }
        }).catch(() => {
            console.error("Error committing the import")
        })
    };

    const handleFileInput = (e) => {
        // handle validations
        const data = new FormData();
        const file = e.target.files[0];
        data.append('file', file);
        base.add("FileUpload/Add", data).then((res) => {
            setPreviewData(res.data);
            setPreviewClick(!previewClick);
        });;
    };

    return (
        <>
            <Modal isOpen size="xl" toggle={toggleModal} backdrop="static">
                <ModalHeader className="page-header" toggle={toggleModal}><div className="md-header">Import Data</div></ModalHeader>

                <ModalBody>
                    {previewClick ?
                        <div className="ag-theme-balham" style={{ height: "390px", width: "100%" }} >
                            <AgGridReact
                                rowData={previewData}
                                columnDefs={importColDef}
                                overlayNoRowsTemplate="No Records Found"
                                defaultColDef={gridDefaultColDef}
                                pagination={true}
                                paginationPageSizeSelector={[10, 20, 50, 100]}
                                paginationPageSize={10}>
                            </AgGridReact>
                        </div>
                        :
                        <form>
                            <input className='input-file'
                                type="file"
                                onChange={handleFileInput}
                            />
                        </form>
                    }
                </ModalBody>
                <ModalFooter>
                    {previewClick &&
                        <Button color="secondary" size="sm" className="btn-text" onClick={() => UploadClick()}>Upload</Button>
                    }
                </ModalFooter>

            </Modal>
        </>
    )
}

export default FileModal
